var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1H8.47368V8.47368H1V1ZM0 8.52637V0H9.47368V8.52637H18.0001V18.0001H9.47368H8.52637H0V9.47368V8.52637ZM9.52637 9.52637H17.0001V17.0001H9.52637V9.52637ZM8.47368 9.52637H1V17.0001H8.47368V9.52637ZM17 2.84211C17 3.85947 16.1753 4.68421 15.1579 4.68421C14.1405 4.68421 13.3158 3.85947 13.3158 2.84211C13.3158 1.82474 14.1405 1 15.1579 1C16.1753 1 17 1.82474 17 2.84211ZM18 2.84211C18 4.41176 16.7276 5.68421 15.1579 5.68421C13.5882 5.68421 12.3158 4.41176 12.3158 2.84211C12.3158 1.27245 13.5882 0 15.1579 0C16.7276 0 18 1.27245 18 2.84211Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamification);
export default __webpack_public_path__ + "static/media/gamification.48aa5e2bf858a065446a2933f61eb205.svg";
export { ForwardRef as ReactComponent };